import React, { useState, useEffect } from "react";
import { EditControl } from "react-leaflet-draw";
import { postShop, deleteFigure } from "../helpers/queries";
import { useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { addedFloor } from "../helpers/actions/index";

export default function MapEditor({
  data,
  map,
  refsReady,
  polygonRefs,
  setDrawnItems,
}) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [createdFigure, setCreatedFigure] = useState(null);

  useEffect(() => {
    if (createdFigure && refsReady) {
      const polygonToOpen = polygonRefs.current[createdFigure];
      polygonToOpen.openPopup();
    }
  }, [refsReady, createdFigure, polygonRefs]);

  const saveObject = useMutation(
    (newObj) => {
      return postShop({
        floorId: data.id,
        data: newObj,
      });
    },
    {
      onSettled: () => {
        dispatch(addedFloor(data.id));
        queryClient.invalidateQueries("floors");
      },
    }
  );

  const deleteObject = useMutation(
    (obj) => {
      const { figureId } = obj;
      return deleteFigure({
        floorId: data.id,
        figureId: figureId,
      });
    },
    {
      onSettled: () => {
        dispatch(addedFloor(data.id));
        queryClient.invalidateQueries("floors");
      },
    }
  );

  const onCreate = (e) => {
    const { layer } = e;

    setDrawnItems((prevArr) => [
      ...prevArr,
      {
        leaflet_obj_id: layer._leaflet_id.toString(),
        coords: layer.getLatLngs()[0],
      },
    ]);

    setCreatedFigure(layer._leaflet_id);
  };

  const onEdited = (e) => {
    Object.keys(e.layers._layers).forEach(function (key) {
      const newObj = {
        map_settings: {
          leafletID:
            e.layers._layers[key]._popup.options.children[0].props.children,
          coords: e.layers._layers[key].getLatLngs()[0],
        },
      };

      saveObject.mutate(newObj);
    });
  };

  const onDeleted = (e) => {
    Object.keys(e.layers._layers).forEach(function (key) {
      deleteObject.mutate({
        floorId: data.id,
        figureId:
          e.layers._layers[key]._popup.options.children[0].props.children,
      });
    });
  };

  return (
    <>
      <EditControl
        position="topleft"
        onCreated={onCreate}
        onEdited={onEdited}
        onDeleted={onDeleted}
        draw={{
          polyline: false,
          circle: false,
          circlemarker: false,
          marker: false,
        }}
      />
    </>
  );
}
